export const menuConstants = {
    TOPBAR_MENU_TYPE_ID: 2,
    MAIN_MENU: 'main',
    FETCH_MENU_REQUEST: 'FETCH_MENU_REQUEST',
    FETCH_MENU_SUCCESS: 'FETCH_MENU_SUCCESS',
    FETCH_MENU_FAILURE: 'FETCH_MENU_FAILURE'
};
